import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { Subtask, Result } from 'constants/interfaces'
import { AppDispatch } from 'config/redux'
import keys from 'constants/keys'
import { updateResults } from 'redux/actions/tasks_v2'
import { useExecutionUpload } from './useExecutionUpload'
import { useTaskOverviewContext } from '../TaskOverviewStackProvider'

export function useExecutionFiles(subtask: Subtask, result?: Result) {
  const lock = useRef(false)
  const files = useRef(result?.files || [])
  const { resultContextId, task, isReadMode, setIsSubtaskBusy } = useTaskOverviewContext()
  const dispatch: AppDispatch = useDispatch()
  const upload = useExecutionUpload(async (url) => {
    const next = [...files.current, url]
    const ok = await dispatch(
      updateResults({
        tid: subtask.tid,
        st_id: subtask.st_id,
        type: subtask.type,
        resultContextId,
        recurrence_ts: task.recurrence_ts,
        files: next,
        status: keys.TASK_STATUSES.DONE.value,
        optimistic: false,
      })
    )
    if (!ok) throw new Error('Save failed')
    files.current = next
  })
  const run = async (operation: () => Promise<void>) => {
    if (isReadMode || upload.busy || lock.current) return
    lock.current = true
    setIsSubtaskBusy(true)
    try {
      await operation()
    } finally {
      lock.current = false
      setIsSubtaskBusy(false)
    }
  }
  useEffect(() => {
    if (!upload.busy) files.current = result?.files || []
  }, [result, upload.busy])
  return { ...upload, add: (selected: File[]) => run(() => upload.add(selected)), retry: () => run(upload.retry) }
}
